export default __webpack_public_path__ + "static/media/Hobbies.9992f706.svg";